(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["cw-front-end-2.0-main"] = factory();
	else
		root["cw-front-end-2.0-main"] = factory();
})(window, function() {
return 